// jshint esversion: 8
const idxById = (state, id) => state.data.findIndex(item => item.id === id);
export default {
  SET_DATA: (state, data) => state.data = data,
  SET_LENGTH: (state, data) => state.length = data,
  SET_COMPLETED: (state, data) => state.completed = data,
  SET_BOOKED: (state, data) => state.booked = data,
  UPDATE_BY_ID: (state, data, id) => state.data[idxById(state, id)] = data,
  SET_UPDATED: (state, data) => state.updated = data
};
